/**
 * @fileoverview load monaco as an npm package instead of from CDN.
 * Refer to https://www.npmjs.com/package/@monaco-editor/react#use-monaco-editor-as-an-npm-package
 */
import Editor, { loader, useMonaco } from "@monaco-editor/react";
import type { EditorProps, Monaco, OnMount } from "@monaco-editor/react";
import * as monaco from "monaco-editor";

const initialized = { current: false };

if (!initialized.current) {
  initialized.current = true;
  loader.config({ monaco });
  // Expose monaco on window so Cypress helpers can drive editor instances directly
  // (cy.type into Monaco's hidden textarea is unreliable under React 18).
  if (typeof window !== "undefined") {
    (window as unknown as { monaco: typeof monaco }).monaco = monaco;
  }
}

export { Editor, useMonaco };
export type { EditorProps, Monaco, OnMount };
